class FloatingImageText extends HTMLElement {
    constructor() {
        super();
        this.button = this.querySelector('.button');
    }
    connectedCallback() {
        this.button.addEventListener('click', function() {
            const productFixedBarToggle = document.querySelector('.product-fixed-bar__toggle');
            if (productFixedBarToggle.parentElement.classList.contains('is-collapsed')) {
                document.querySelector('.product-fixed-bar__toggle').click();
            }           
        });
    }
}
if (!customElements.get('floating-image-text')) {
    customElements.define('floating-image-text', FloatingImageText);
}